<template>
  <div class="agency-survey-container">
    <div class="main-width">
      <div class="agency-survey-wrap">
        <div class="agency-survey-left">
          <div class="player-container">
            <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions">
            </video-player>
          </div>
        </div>
        <div class="agency-survey-right">
          <h2>{{ data.title }}</h2>
          <p>{{ data.summary }}</p>
          <router-link class="more-info" :to="data.detailUrl" target="_blank" v-if="!isHttp(data.detailUrl)">
            <span>了解更多&nbsp;<i class="el-icon-right"></i></span>
          </router-link>
          <a class="more-info" :href="data.detailUrl" target="_blank" v-else>
            <span>了解更多&nbsp;<i class="el-icon-right"></i></span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], //可选择的播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        // width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, //当前时间和持续时间的分隔符
          durationDisplay: true, //显示持续时间
          remainingTimeDisplay: false, //是否显示剩余时间功能
          fullscreenToggle: true, //全屏按钮
        },
        sources: [
          {
            type: "video/mp4",
            src: this.data.video, //url地址
          },
        ],
        poster: this.data.poster, //你的封面地址
      }
    }
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {

  },
  mounted() {

  },
  methods: {
    isHttp(path) {
      const httpsRE = /^https?:\/\//;
      return httpsRE.test(path);
    }
  },
}
</script>

<style lang="less" scoped>
.agency-survey-container {
  background: #f1f4fb;
  // padding: 40px 0;
  .agency-survey-wrap {
    // box-shadow: 0px 0px 4px 4px rgba(0, 0, 0, 0.12);
    padding: 20px;
    display: flex;
    align-items: center;
    background: #e6f4fe;
    .agency-survey-left {
      width: 60%;
      height: 435px;
      ::v-deep .vjs-poster {
        background-size: contain;
      }
      .player-container {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .video-player {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .agency-survey-right {
      width: 40%;
      padding: 20px 32px;
      h2 {
        font-size: 24px;
        color: #212529;
      }
      p {
        font-size: 16px;
        text-indent: 32px;
        line-height: 32px;
        margin-top: 20px;
        color: #333;
        display: -webkit-box;
        overflow: hidden;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 6;
      }
    }
    .more-info {
      display: flex;
      justify-content: flex-end;
      font-size: 16px;
      color: #212529;
      line-height: 32px;
      span {
        border-bottom: 2px solid #2960a7;
        font-weight: 600;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .agency-survey-container {
    background: #f1f4fb;
    padding: 14px;
    margin: 14px 0;
    .agency-survey-wrap {
      box-shadow: 0px 0px 2px 2px rgba(0, 0, 0, 0.12);
      padding: 14px;
      flex-direction: column;
      background: #e6f4fe;
      .agency-survey-left {
        width: 100%;
        height: auto;
        ::v-deep .vjs-poster {
          background-size: contain;
        }
      }
      .agency-survey-right {
        width: 100%;
        padding: 14px;
        h2 {
          font-size: 18px;
        }
        p {
          font-size: 14px;
          text-indent: 28px;
          line-height: 28px;
          margin-top: 14px;
          color: #333;
        }
      }
      .more-info {
        font-size: 12px;
        line-height: 24px;
        span {
          border-bottom: 1px solid #2960a7;
          font-weight: 500;
        }
      }
    }
  }
}
</style>